import { render, staticRenderFns } from "./job-roles.vue?vue&type=template&id=6554babd"
import script from "./job-roles.vue?vue&type=script&lang=js"
export * from "./job-roles.vue?vue&type=script&lang=js"
import style0 from "./job-roles.vue?vue&type=style&index=0&id=6554babd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports